import type { CSSProperties, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface ListWrapperProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const ListWrapper = ({
  children,
  className,
  style,
}: ListWrapperProps) => (
  // h-[calc(100%-92px)] is the height of the list minus the height of the header, tabs and margin.
  <div
    className={classNames(
      "flex h-[calc(100dvh-95px)] w-full flex-col justify-between space-y-px overflow-y-auto p-2 [scrollbar-gutter:stable] lg:h-[calc(100%-92px)]",
      className,
    )}
    style={style}
    id="user-notifications-panel-header"
  >
    {children}
  </div>
);
